<template>
  <div class="home-ws">
    <Card shoaw>
      <Row :gutter="20">
        <i-col :xs="24" :md="8" :lg="4" v-for="(infor, i) in inforCardData" :key="`infor-${i}`" style="height: 120px;padding-bottom: 10px;">
          <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="36">
            <!--<count-to :end="infor.count" count-class="count-style"/>-->
            <span class="count-style">{{ infor.count }}</span>
            <p>{{ infor.title }}</p>
          </infor-card>
        </i-col>
      </Row>
      <Row style="padding-bottom: 10px;">
        <div style="float: left"><h2>工单统计</h2></div>
        <div style="float: right">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @keyup.enter.native="searchSubmit">
            <FormItem label="分类" prop="type">
              <Select v-model="searchForm.type" placeholder="" style="min-width: 150px;" filterable  multiple @on-change="onSelectType">
                <Option v-for="item in workSheetTypeList" :key="item.id" :value="item.id">{{ item.type_name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="处理人" prop="operator">
               <Select v-model="searchForm.operators" filterable  multiple @on-change="onSelectOperator">
                <Option v-for="item in user_all" :value="item.id" :key="item.id" :label="item.name"></Option>
               </Select>
            </FormItem>
             <FormItem label="时间区间">
                <DatePicker
                            v-model="customTime"
                            :editable="false"
                            type="daterange"
                            style="min-width: 250px;"
                            format="yyyy-MM-dd"
                            @on-change="customTimeChange"
                            :clearable="false"
                            class="mob-w-100"
                            placeholder="自定义时间"></DatePicker>
            </FormItem>
            </Form>
        </div>
      </Row>
      <Row>
        <Col :xs="24" :md="24" :lg="24" style="margin-bottom: 20px">
          <Card>
            <div :style="{height: '350px'}" id="worksheet_line"></div>
          </Card>
        </Col>
        <Col :xs="24" :md="24" :lg="24" style="margin-bottom: 20px">
          <Card>
            <div :style="{height: '350px'}" id="worksheet_type_pie"></div>
            <div style="text-align: left;height: 20px;margin-bottom: 30px">
               <InputNumber :max="39" :min="1" v-model="valueParent"></InputNumber>
               <a v-on:click="handleTypeShow" style="line-height: 20px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
            </div>
          </Card>
        </Col>
        <!-- <Col :xs="24" :md="24" :lg="24" style="margin-bottom: 20px">
          <Card>
            <div :style="{height: '350px'}" id="worksheet_source_pie"></div>
          </Card>
        </Col> -->
        <Col :xs="24" :md="24" :lg="12" style="margin-bottom: 20px">
          <Card>
            <div :style="{height: '350px'}" id="worksheet_response_range_id">
              <div style="text-align: center"><h3>工单响应时间</h3></div>
              <div class="time_l_class">0~1小时（{{ response_time_count.one_hours }}）</div>
              <Progress :percent="response_time_count.one_hours_percent" hide-info />
              <div class="time_l_class">1~8小时（{{ response_time_count.one_to_eight_hours }}）</div>
              <Progress :percent="response_time_count.one_to_eight_hours_percent" hide-info />
              <div class="time_l_class">8~24小时（{{ response_time_count.eight_to_one_day }}）</div>
              <Progress :percent="response_time_count.eight_to_one_day_percent" hide-info />
              <div class="time_l_class">超过24小时（{{ response_time_count.more_than_one_day }}）</div>
              <Progress :percent="response_time_count.more_than_one_day_percent" hide-info />
            </div>
          </Card>
        </Col>
        <Col :xs="24" :md="24" :lg="12" style="margin-bottom: 20px">
          <Card>
            <div :style="{height: '350px'}" id="worksheet_solve_range_id">
              <div style="text-align: center"><h3>工单解决时间</h3></div>
              <div class="time_l_class">0~1小时（{{ solve_time_count.one_hours }}）</div>
              <Progress :percent="solve_time_count.one_hours_percent" hide-info />
              <div class="time_l_class">1~8小时（{{ solve_time_count.one_to_eight_hours }}）</div>
              <Progress :percent="solve_time_count.one_to_eight_hours_percent" hide-info />
              <div class="time_l_class">8~24小时（{{ solve_time_count.eight_to_one_day }}）</div>
              <Progress :percent="solve_time_count.eight_to_one_day_percent" hide-info />
              <div class="time_l_class">超过24小时（{{ solve_time_count.more_than_one_day }}）</div>
              <Progress :percent="solve_time_count.more_than_one_day_percent" hide-info />
            </div>
          </Card>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import echarts from 'echarts'
import 'echarts/theme/roma.js'
import { GetTimeIntervalAmount, GetAllCount } from '@/api/logistics/dashboard'
import { GetALLWorkSheetType } from '@/api/logistics/type'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'home-ws',
  components: {
    InforCard,
    CountTo
  },
  data () {
    return {
      searchForm: {
        operators: [],
        type: []
      },
      user_all: [],
      typeNameListAll: [],
      type_data_list_all: [],
      valueParent: 39,
      typeSel: '',
      workSheetTypeList: [],
      customTime: '',
      startTime: '',
      parentType: '',
      endTime: '',
      inforCardData: [
        { title: '工单总数', icon: 'md-help-buoy', count: 0, color: '#2d8cf0' },
        { title: '工单处理量', icon: 'md-locate', count: 0, color: '#19be6b' },
        { title: '工单关闭量', icon: 'md-checkmark-circle-outline', count: 0, color: '#ff9900' },
        { title: '工单解决率(%)', icon: 'md-podium', count: 0, color: '#ed3f14' },
        { title: '平均响应时间(小时)', icon: 'md-happy', count: 0, color: '#E46CBB' },
        { title: '平均处理时间(小时)', icon: 'md-chatbubbles', count: 0, color: '#9A66E4' }
      ],
      worksheet_line_option: {
        tooltip: {
          trigger: 'axis',
          position: function (p) { // 其中p为当前鼠标的位置
            return [p[0] + 10, p[1] - 10]
          }
        },
        legend: {
          data: ['工单数量']
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#000000'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#000000'
            }
          }
        },
        series: [{
          name: '工单数量',
          data: [],
          type: 'line',
          smooth: true,
          itemStyle: { normal: { label: { show: true } } }
        }]
      },
      worksheet_type_option: {
        title: {
          text: '工单大类',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: []
        },
        series: [
          {
            name: '工单大类',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                formatter: '{c} {per|{d}%}\n  ',
                rich: {
                  a: {
                    color: '#999',
                    lineHeight: 15,
                    align: 'center'
                  },
                  b: {
                    fontSize: 12
                  },
                  per: {
                    color: '#eee',
                    backgroundColor: '#334455',
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              }
              // normal:{
              //   show:true,
              //   position:'inner', //标签的位置
              //   textStyle : {
              //     fontWeight : 300 ,
              //     fontSize : 16    //文字的字体大小
              //   },
              //   formatter:'{d}%'
              // }
            }
          }
        ]
      },
      worksheet_source_option: {
        title: {
          text: '工单来源',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: []
        },
        series: [
          {
            name: '工单来源',
            type: 'pie',
            radius: '60%',
            center: ['50%', '60%'],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                formatter: '{c} {per|{d}%}\n  ',
                rich: {
                  a: {
                    color: '#999',
                    lineHeight: 15,
                    align: 'center'
                  },
                  b: {
                    fontSize: 12
                  },
                  per: {
                    color: '#eee',
                    backgroundColor: '#334455',
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              }
            }
          }
        ]
      },
      day_count_list: [],
      date_list: [],
      total_count: 0,
      response_time_count: {
        one_hours: 0,
        one_to_eight_hours: 0,
        eight_to_one_day: 0,
        more_than_one_day: 0,
        one_hours_percent: 0,
        one_to_eight_hours_percent: 0,
        eight_to_one_day_percent: 0,
        more_than_one_day_percent: 0,
        average: 0
      },
      solve_time_count: {
        one_hours: 0,
        one_to_eight_hours: 0,
        eight_to_one_day: 0,
        more_than_one_day: 0,
        one_hours_percent: 0,
        one_to_eight_hours_percent: 0,
        eight_to_one_day_percent: 0,
        more_than_one_day_percent: 0,
        average: 0
      },
      source_count: 0,
      type_count: 0,

      worksheet_total_count: 0,
      worksheet_process_count: 0,
      worksheet_solved_rate: 0,
      worksheet_response_time_count: 0,
      worksheet_solve_time_count: 0
    }
  },
  created () {
    // this.getBaseAllCount()
    this.customTime = [new Date(new Date().setDate(new Date().getDate() - 30)), new Date()]
    this.customTimeChange()
  },
  mounted () {
    this.getWorkSheetAllTypeList()
    this.fetchAllUserData()
  },
  methods: {
    onSelectOperator () {
      this.getTimeCount()
    },
    onSelectType () {
      this.getTimeCount()
    },
    fetchAllUserData () {
      GetALLUsers().then(res => {
        this.user_all = res.data
      })
    },
    handleTypeShow () {
      console.log(this.typeNameListAll)
      this.worksheet_type_option.series[0].data = this.type_data_list_all.slice(0, this.valueParent)
      let graphLine2 = echarts.init(document.getElementById('worksheet_type_pie'), 'roma')
      graphLine2.clear()
      graphLine2.setOption(this.worksheet_type_option, true)
    },
    getWorkSheetAllTypeList () {
      GetALLWorkSheetType().then(res => {
        this.workSheetTypeList = res.data
      })
    },
    customTimeChange () {
      let timeRange = [this.customTime[0].getTime() / 1000, this.customTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.startTime = timeRange[0]
        this.endTime = timeRange[1]
      } else {
        this.startTime = ''
        this.endTime = ''
      }
      this.getTimeCount()
    },
    customTimeClear () {
      this.startTime = ''
      this.endTime = ''
    },
    getTimeCount () {
      let reqData = {
        start_date: this.startTime,
        end_date: this.endTime,
        type: this.searchForm.type,
        operators: this.searchForm.operators
      }
      GetTimeIntervalAmount(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.day_count_list = result.data.day_count_list
          this.date_list = result.data.date_list
          // this.total_count = result.data.total_count
          this.source_count = result.data.source_count
          this.type_count = result.data.type_count
          this.type_count_son = result.data.type_count_son
          // 最上面一排数据统计
          this.worksheet_total_count = result.data.worksheet_total_count
          this.worksheet_process_count = result.data.worksheet_process_count
          this.worksheet_closed_count = result.data.worksheet_closed_count
          this.worksheet_solved_rate = result.data.worksheet_solved_rate
          // this.worksheet_response_time_count = result.data.worksheet_response_time_count
          // this.worksheet_solve_time_count = result.data.worksheet_solve_time_count
          this.inforCardData = [
            { title: '工单总数', icon: 'md-help-buoy', count: this.worksheet_total_count, color: '#2d8cf0' },
            { title: '工单处理量', icon: 'md-locate', count: this.worksheet_process_count, color: '#19be6b' },
            { title: '工单关闭量', icon: 'md-checkmark-circle-outline', count: this.worksheet_closed_count, color: '#ff9900' },
            { title: '工单解决率(%)', icon: 'md-podium', count: this.worksheet_solved_rate, color: '#ed3f14' },
            { title: '平均响应时间(小时)', icon: 'md-happy', count: result.data.response_time_count.average, color: '#E46CBB' },
            { title: '平均处理时间(小时)', icon: 'md-chatbubbles', count: result.data.solve_time_count.average, color: '#9A66E4' }
          ]

          // 工单每天总量折线图
          this.worksheet_line_option.xAxis.data = this.date_list
          this.worksheet_line_option.series[0].data = this.day_count_list
          let graphLine = echarts.init(document.getElementById('worksheet_line'), 'roma')
          window.addEventListener('resize', function () {
            echarts.init(document.getElementById('worksheet_line'), 'roma').resize()
          })
          graphLine.clear()
          graphLine.setOption(this.worksheet_line_option, true)
          // 工单分类饼图
          let typeNameList = []
          let typeDataList = []
          for (let v in this.type_count) {
            typeNameList.push(v)
            typeDataList.push({ value: this.type_count[v], name: v })
          }
          this.typeNameListAll = typeNameList
          this.type_data_list_all = typeDataList
          this.worksheet_type_option.legend.data = typeNameList
          this.worksheet_type_option.series[0].data = this.type_data_list_all.slice(0, this.valueParent)
          let graphLine2 = echarts.init(document.getElementById('worksheet_type_pie'), 'roma')
          window.addEventListener('resize', function () {
            echarts.init(document.getElementById('worksheet_type_pie'), 'roma').resize()
          })
          graphLine2.clear()
          graphLine2.setOption(this.worksheet_type_option, true)

          // 工单来源饼图
          // console.log(1111111)
          // let sourceNameList = []
          // let sourceDataList = []
          // for (let v in this.source_count) {
          //   sourceNameList.push(v)
          //   sourceDataList.push({ value: this.source_count[v], name: v })
          // }
          // this.worksheet_source_option.legend.data = sourceNameList
          // this.worksheet_source_option.series[0].data = sourceDataList
          // let graphLine3 = echarts.init(document.getElementById('worksheet_source_pie'), 'roma')
          // window.addEventListener('resize', function () {
          //   echarts.init(document.getElementById('worksheet_source_pie'), 'roma').resize()
          // })
          // graphLine3.clear()
          // graphLine3.setOption(this.worksheet_source_option, true)
          // console.log(222222)
          // 响应时间
          let responseTotal = (result.data.response_time_count.one_hours +
            result.data.response_time_count.one_to_eight_hours +
            result.data.response_time_count.eight_to_one_day +
            result.data.response_time_count.more_than_one_day)
          this.response_time_count.one_hours_percent = responseTotal ? result.data.response_time_count.one_hours / responseTotal * 100 : 0
          this.response_time_count.one_to_eight_hours_percent = responseTotal ? result.data.response_time_count.one_to_eight_hours / responseTotal * 100 : 0
          this.response_time_count.eight_to_one_day_percent = responseTotal ? result.data.response_time_count.eight_to_one_day / responseTotal * 100 : 0
          this.response_time_count.more_than_one_day_percent = responseTotal ? result.data.response_time_count.more_than_one_day / responseTotal * 100 : 0
          this.response_time_count.average = result.data.response_time_count.average
          this.response_time_count.one_hours = result.data.response_time_count.one_hours
          this.response_time_count.one_to_eight_hours = result.data.response_time_count.one_to_eight_hours
          this.response_time_count.eight_to_one_day = result.data.response_time_count.eight_to_one_day
          this.response_time_count.more_than_one_day = result.data.response_time_count.more_than_one_day
          console.log(result.data.response_time_count.more_than_one_day)

          // 解决时间
          let solveTotal = (result.data.solve_time_count.one_hours +
            result.data.solve_time_count.one_to_eight_hours +
            result.data.solve_time_count.eight_to_one_day +
            result.data.solve_time_count.more_than_one_day)
          this.solve_time_count.one_hours_percent = solveTotal ? result.data.solve_time_count.one_hours / solveTotal * 100 : 0
          this.solve_time_count.one_to_eight_hours_percent = solveTotal ? result.data.solve_time_count.one_to_eight_hours / solveTotal * 100 : 0
          this.solve_time_count.eight_to_one_day_percent = solveTotal ? result.data.solve_time_count.eight_to_one_day / solveTotal * 100 : 0
          this.solve_time_count.more_than_one_day_percent = solveTotal ? result.data.solve_time_count.more_than_one_day / solveTotal * 100 : 0
          this.solve_time_count.average = result.data.solve_time_count.average
          this.solve_time_count.one_hours = result.data.solve_time_count.one_hours
          this.solve_time_count.one_to_eight_hours = result.data.solve_time_count.one_to_eight_hours
          this.solve_time_count.eight_to_one_day = result.data.solve_time_count.eight_to_one_day
          this.solve_time_count.more_than_one_day = result.data.solve_time_count.more_than_one_day
        }
      })
    },
    getBaseAllCount () {
      GetAllCount().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.inforCardData = [
            { title: '工单总数', icon: 'md-help-buoy', count: result.data.worksheet_total_count, color: '#2d8cf0' },
            { title: '工单处理量', icon: 'md-locate', count: result.data.worksheet_process_count, color: '#19be6b' },
            { title: '工单关闭量', icon: 'md-checkmark-circle-outline', count: result.data.worksheet_closed_count, color: '#ff9900' },
            { title: '工单解决率(%)', icon: 'md-podium', count: result.data.worksheet_solved_rate, color: '#ed3f14' },
            { title: '平均响应时间(小时)', icon: 'md-happy', count: result.data.worksheet_response_time_count, color: '#E46CBB' },
            { title: '平均处理时间(小时)', icon: 'md-chatbubbles', count: result.data.worksheet_solve_time_count, color: '#9A66E4' }
          ]
        }
      })
    }
  }
}
</script>

<style lang="less">
  .count-style{
    font-size: 40px;
  }
  .ivu-progress {
    margin-bottom: 20px;
  }
  .time_l_class {
    margin-top: 10px;
  }
  .home-ws .info-card-wrapper .content-con .right-area{
    border: 1px solid #eee;
  }
</style>
